<mwe-basic-card
  [headingNodeType]="headlineService.getHeadline(0)"
  cardTitle="tariff.additionalOptions.title"
  iconClass="fa-box-circle-check"
>
  <div class="row g-3">
    <div class="col-12">
      <label
        [attr.aria-description]="isReadOnly() ? ('newClient.disabled' | translate) : null"
        [attr.title]="title() + ' wählen'"
        [ngClass]="[!isReadOnly() ? 'p-4' : '']"
        class="card-selectable mb-0"
        data-test="additional-options-checkbox"
      >
        <div class="row justify-content-between mb-3">
          <div class="col-auto">
            <i class="fa text-secondary" [class]="iconClass()" style="font-size: 2.5rem"></i>
          </div>

          <div class="col-auto">
            <div class="form-check">
              <input
                (change)="onCheckboxChange()"
                [attr.aria-label]="title()"
                [checked]="isSelected()"
                [disabled]="isCheckBoxDisabled()"
                class="form-check-input"
                type="checkbox"
              />
            </div>
          </div>
        </div>
        <mwe-headline [headlineLevelIncrement]="1" [text]="title()" cssClass="h6" data-test="tariff-card-additional-options-title" />
        <p class="mb-1">{{ description() | translate }}</p>
        <p class="text--legal mb-0">{{ tariff().category | correlatedCompanyReference }}</p>
      </label>
    </div>

    @if (isSelected()) {
      <div class="col-12">
        <div class="form-floating">
          <select
            class="form-select"
            id="tv-paket-select"
            name="tv-paket-select"
            data-test="tv-paket-select"
            [class.form-select--readonly]="isReadOnly()"
            [attr.aria-description]="isReadOnly() ? ('newClient.disabled' | translate) : null"
            [disabled]="isReadOnly()"
            (change)="selectOption($event.target)"
          >
            @for (option of dropdownOptions(); track option.produktKey) {
              <option [value]="option.produktKey" [selected]="option.produktKey === selectedTvOption()">
                {{ option.tvOption }}
              </option>
            }
          </select>
          <label for="tv-paket-select" class="form-label">TV-Paket</label>
        </div>
      </div>
      @if (isMobile()) {
        <div [attr.id]="'tv-option-help-label'" class="col-12 font-size-12 text-neutral-600 mt-1" data-test="tv-option-help-label">
          <div class="row gx-1">
            <div class="col-auto"><i class="fa fa-info-circle" aria-hidden="true"></i></div>
            <div class="col-auto"><span [translate]="helpLabel()"></span></div>
          </div>
        </div>
      }
      <div class="col-12" data-test="tv-product-details">
        <p class="fw-bold text-secondary mb-2" [translate]="productDetailsTitle()"></p>
        <p class="mb-0" [translate]="productDetailsText()"></p>
      </div>
      @if (tariffSheetUrls()?.['tvProducts']) {
        <div class="col-12" data-test="tv-product-link">
          <a
            class="btn btn-link btn-link--dark-blue text-decoration-underline"
            [href]="tariffSheetUrls()?.['tvProducts']"
            target="_blank"
            [translate]="tvProductLinkLabel()"
          ></a>
        </div>
      }
      <hr />
      <div class="col-12 mt-0" data-test="base-price-label">
        <p class="mb-1 fw-bold text-secondary" [translate]="basePriceLabel()"></p>
      </div>
      <div class="col-12 mt-0" data-test="base-price">
        <span class="h3">{{ basePrice() }}</span
        >&nbsp;
        <span class="h3" [translate]="basePriceUnit()"></span>
      </div>
      @if (tariffSheetUrls()?.['tvTarif']) {
        <div class="col-12" data-test="tariff-link">
          <a
            class="btn btn-link btn-link--dark-blue fw-bold text-decoration-underline"
            [href]="tariffSheetUrls()?.['tvTarif']"
            target="_blank"
            [translate]="tariffLinkLabel()"
          ></a>
        </div>
      }
    }
  </div>
</mwe-basic-card>
